// @ts-nocheck

import { css } from 'styled-components';

const CollapseStyles = css`
  .CollapseListItem-collapse {
    transition: height 350ms;
  }
`;

export default CollapseStyles;
